import React, { useEffect, useState } from 'react';
import { LogHistorydiv, MainTitle, Paginatior } from './LogHistory.style';
import axiosInstance from '../../../core/axiosInstance';
import Card from '../../../components/Card/Card';
import { useAppDispatch } from '../../../core/hooks';
import { setLoading } from '../../../features/loading/loadingSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBackward, faFastBackward, faForward, faTrash } from '@fortawesome/free-solid-svg-icons';

import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { useCallback } from 'react';
import Spinner from '../../../components/Spinner/Spinner';
// import Spinner from '../../../components/Spinner/Spinner';

const LogHistory = () => {
    const [actions, setactions] = useState([]);
    const [totalRecode, setTotalRecode] = useState<number>(0);
    const [nextLink, setNextLink] = useState<string>('');
    const [prevLink, setPrevLink] = useState<string>('');
    const [firstLink, setFirstLink] = useState<string>('');
    const [lastLink, setLastLink] = useState<string>('');
    const [loader, setLoader] = useState<boolean>(false)
    const dispatch = useAppDispatch();
    dispatch(setLoading(false))

    const [currentPage, setcurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(5);

    const [perfix, setPerfix] = useState<string>('/dashboard/action-logs');

    const cols = [
        {
            field: 'name', Name: 'Announcement Name', sortable: false, filter: false, filterPlaceholder: '', body: false,
        },
        {
            field: 'action', Name: 'Action', sortable: false, filter: false, filterPlaceholder: '', body: false,
        },
        {
            field: 'status', Name: 'Status', sortable: false, filter: false, filterPlaceholder: '', body: false,
        },
        {
            field: 'date', Name: 'Date', sortable: false, filter: false, filterPlaceholder: '', body: false,
        },
    ];

    const getStatus: any = (obj: any) => {
        const timeBeforstart = new Date(`${obj.page.start_at}`).getTime() - new Date().getTime();
        const timeBeforEnd = new Date(`${obj.page.expiry_at}`).getTime() - new Date().getTime();

        if (obj.page.status === 1) {
            if (timeBeforstart > 0) {
                return 'Pending';
            } else if (timeBeforstart < 0 && timeBeforEnd > 0) {
                return 'Published';
            } else {
                //start < 0 && end < 0
                return 'Expired';
            }
        }
        //status != 1
        else {
            if (timeBeforEnd > 0) {
                return 'draft';
            } else if (timeBeforEnd < 0) {
                return 'Expired';
            }
        }
    };

    const data: any = [];

    actions.forEach((action: any, index: number) => {
        data.push({
            id: action.id, name: action.page.name, action: action.action,
            status: getStatus(action), date: action.date.split('.')[0].split('T')[0],
        });
    });
    const controller = new AbortController();
    const getData = async () => {
        setLoader(true)
        let queryString = `/dashboard/action-logs?page=${currentPage}`;
        await axiosInstance
            .get(queryString,{
                signal: controller.signal
              })
            .then((res: any) => {

                setLastPage(res.data.meta.last_page)
                setactions(res.data.data);
                setTotalRecode(res.data.meta.total);
                setLoader(false)
            })
            .catch(error => {
                setLoader(false);
            })
    }

    useEffect(() => {
        getData();
    }, [currentPage]);

    useEffect(()=>{
            return () => controller?.abort();
    },[])
   
    const handleChange = (e: any) => {
        if (Number(e.target.innerText)) setcurrentPage(Number(e.target.innerText))
        if (e.target.nodeName === 'svg') {

            if (e.target.getAttribute('data-testid') === 'NavigateNextIcon') {
                setcurrentPage(currentPage + 1)
            }
            if (e.target.getAttribute('data-testid') === 'NavigateBeforeIcon') {
                setcurrentPage(currentPage - 1)
            }
            if (e.target.getAttribute('data-testid') === 'LastPageIcon') {
                setcurrentPage(5)
            }
            if (e.target.getAttribute('data-testid') === 'FirstPageIcon') {
                setcurrentPage(1)
            }
        }

    }



    return (
        <LogHistorydiv>
            {(data.length <= 0 || loader) && <Spinner />}
            {/* <ConfirmDialog /> */}
            <div>
                <MainTitle title="History Of ActionsP"></MainTitle>
            </div>
            <Card
                hasFilter={false}
                title="History"
                cols={cols}
                data={data}
                actions={[]}
                totalRecode={totalRecode}
                setactions={setactions}
            />
            <Paginatior className="Pagination-center history">
                <Stack spacing={2}>
                    <Pagination
                        siblingCount={1} boundaryCount={1}
                        count={Number(lastPage)}
                        defaultPage={1}
                        page={Number(currentPage)}
                        variant="outlined"
                        onChange={(e) => handleChange(e)}
                    />
                </Stack>

            </Paginatior>
        </LogHistorydiv>
    );
};

export default LogHistory;



